export default __webpack_public_path__ + "static/media/help-environment.8325a5df.png";